import React, { useMemo } from 'react'
import type { UseFormHandleSubmit } from 'react-hook-form'
import { useIntl } from 'react-intl'

import LineTrashAltIcon from 'LuxKit/Icons/line/LineTrashAltIcon'
import ModalFooter from 'LuxKit/Modal/ModalFooter'

interface Props {
  onSubmit: ReturnType<UseFormHandleSubmit<any>>
  deleteItem: () => void
  isLoading: boolean
}

function EditModalFooter(props: Props) {
  const { onSubmit, deleteItem, isLoading } = props
  const intl = useIntl()
  const trashIcon = useMemo(() => <LineTrashAltIcon />, [])

  const saveButtonLabel = intl.formatMessage({
    id: 'KHld4ZqddYegTW2hZy2s',
    defaultMessage: 'Save',
    description: 'Button label to save changes when editing a trip item',
  })

  const deleteButtonLabel = intl.formatMessage({
    id: 'ovzaB_T1SfLUtJbENWAG',
    defaultMessage: 'Delete',
    description: 'Button label to delete a trip item in the trip planner feature',
  })

  return (
    <ModalFooter
      primaryActionProps={{
        children: saveButtonLabel,
        disabled: isLoading,
        onClick: onSubmit,
      }}
      secondaryActionProps={{
        children: deleteButtonLabel,
        disabled: isLoading,
        onClick: deleteItem,
        startIcon: trashIcon,
      }}
    />
  )
}

export default EditModalFooter
